import React from "react";
import "./CheckboxGroup.scss";
import { CheckboxContext } from "../../../../context/Checkbox/CheckboxContext";

const CheckboxGroup = ({
  label,
  children,
  disabled: groupDisabled,
  values,
  onChange,
  $flexstart,
 ...rest
}) => {
  const isDisabled = (disabled) => disabled || groupDisabled;

  const isChecked = (value) => values.includes(value);

  const toggleValue = ({ checked, value }) => {
    if (checked) {
      onChange([...values, value]);
    } else {
      onChange(values.filter((v) => v!== value));
    }
  };

  return (
    <fieldset className="group-layout" {...rest}>
      <div className={`group-box ${$flexstart? "group-box--flex-start" : ""}`}>
        <CheckboxContext.Provider value={{ isDisabled, isChecked, toggleValue }}>
          {children}
        </CheckboxContext.Provider>
      </div>
    </fieldset>
  );
};

export default CheckboxGroup;
